import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Image from 'components/Image';
import makeClasses from 'hooks/useClasses';
import React from 'react';
import styles from 'styles/jss/components/bookSizeDialogStyle';
import Typography from '@mui/material/Typography';

const tiles = [
  {
    chip: 'Quality Hardcovers',
    description: 'Our matte hardcovers are durable and vibrant. They\'ll fit right in on any bookshelf.',
    src: '/img/marketing/hard_cover_coffee.jpg'
  },
  {
    chip: 'Simple Sizing',
    description: 'Choose from 8.5"x8.5" or 11"x8.5" sizes to showcase creations of all shapes and sizes.',
    src: '/img/marketing/book_sizes.jpg'
  },
  {
    chip: 'Premium Photo Paper',
    description: 'Our 100# coated premium paper is an ultra-smooth, high opacity paper that emphasizes the rich colors of the artwork.',
    src: '/img/marketing/feat_carousel_paper.jpg'
  },
  {
    chip: 'Every Photo is Print Worthy',
    description: 'You don\'t have to be an amazing photographer. Watch Scribble\'s A.I. transform your photos in real-time.',
    src: '/img/marketing/before_after.gif'
  }
];

const FeaturesTiles = () => {
  const classes = makeClasses(styles);

  return (
    <Grid
      container
      item
      className={classes.featuresSection}
      spacing={5}
      sx={{ px: 5 }}
    >
      {tiles.map((slide) => (
        <Grid
          className="featureTile"
          item
          xs={12}
          md={6}
          key={slide.src}
        >
          <Box className="featureImage">
            <Image
              src={slide.src}
              alt="Scribble book sizes"
              layout="fill"
              objectFit="cover"
            />
          </Box>
          <Typography
            variant="bookPreview"
            component="h1"
          >
            {slide.chip}
          </Typography>
          <Typography
            component="h2"
            className="carouselLabel"
          >
            {slide.description}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};

export default FeaturesTiles;
